/** Derive a snake_case variable key from a human name (e.g. "Favorite Color" → "favorite_color"). */
export function slugifyVariableKey(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/^([0-9])/, '_$1');
}
